export const getScreenHeight = (click, collapse) => {
  if (document.getElementById('card-section') !== null && document.getElementById('header-section') === null) {
    let screenHeight = document.getElementById('card-section').offsetHeight;
    document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - 100px); overflow: auto;');
  }
  else if (document.getElementById('card-section') !== null && document.getElementById('header-section') !== null) {
    let screenHeight = document.getElementById('card-section').offsetHeight;
    let filterHeight = document.getElementById('header-section').offsetHeight + 15;
    if (click === 'click') {
      if (collapse === 1) {
        filterHeight = 54;
      } else {
        filterHeight = 177;
      }
    }
    document.querySelector('#table-section .react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - ' + filterHeight + 'px - 60px); overflow: auto;');
    // document.querySelector('.action_row').setAttribute('style', 'top: calc(' + screenHeight + 'px - 53px);');
  }
  // let screenHeight = document.getElementById('card-section').offsetHeight;
};